<div class="sale-items-popup-container page-root-container">
  <h2 mat-dialog-title style="margin-top: -24px;">Group Items - {{ data.groupName }}</h2>

  <mat-dialog-content class="dialog-content"
    style="display: flex; flex-direction: column;overflow: hidden;min-height: 340px;">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-text">Loading...</div>
    </div>

    <div *ngIf="!isLoading" class="table-scroll-container">
      <div *ngIf="saleItems && saleItems.length === 0" class="no-data-container">
        <div class="no-data-message">
          <mat-icon style="font-size: 25px; color: #9e9e9e;">inbox</mat-icon>
          <span>There are no sale items in this group.</span>
        </div>
      </div>

      <table *ngIf="saleItems && saleItems.length > 0" mat-table [dataSource]="saleItems" class="sale-items-table"
        style="width: 100%;">
        <!-- Serial Number Column -->
        <ng-container matColumnDef="sl">
          <th mat-header-cell *matHeaderCellDef class="table-header"
            style="position: sticky; top: 0; background: white; z-index: 10; border-bottom: 1px solid #e0e0e0;">Sl</th>
          <td mat-cell *matCellDef="let item" class="table-cell">{{ item.sl }}</td>
        </ng-container>

        <!-- Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef class="table-header"
            style="position: sticky; top: 0; background: white; z-index: 10; border-bottom: 1px solid #e0e0e0;">Code
          </th>
          <td mat-cell *matCellDef="let item" class="table-cell">
            <!-- <mat-form-field class="table-input" style="width: 80px;"> -->
            <mat-label>{{item.code}}</mat-label>
            <!-- </mat-form-field> -->
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="table-header">Name</th>
          <td mat-cell *matCellDef="let item" class="table-cell">
            <!-- <mat-form-field class="table-input"> -->
            <mat-label>{{item.name}}</mat-label>
            <!-- </mat-form-field> -->
          </td>
        </ng-container>

        <!-- Short Name Column -->
        <ng-container matColumnDef="shortName">
          <th mat-header-cell *matHeaderCellDef class="table-header">Short Name</th>
          <td mat-cell *matCellDef="let item" class="table-cell">
            <mat-form-field class="table-input" style="width: 200px;">
              <input matInput [(ngModel)]="item.shortName">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Display Order Column -->
        <ng-container matColumnDef="displayOrder">
          <th mat-header-cell *matHeaderCellDef class="table-header">Display Order</th>
          <td mat-cell *matCellDef="let item" class="table-cell">
            <mat-form-field class="table-input" style="width: 65px;">
              <input matInput type="number" [(ngModel)]="item.displayOrder" class="number-input">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="table-header">Actions</th>
          <td mat-cell *matCellDef="let item" class="table-cell">
            <button 
              mat-icon-button 
              color="warn" 
              (click)="onDeleteItem(item)" 
              matTooltip="Delete Item"
              class="delete-button">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" class="submit-button">Update</button>
  </mat-dialog-actions>
</div>